import { useGoogleTranslate } from '../Hooks/useGoogleTranslate';

const TranslatedText = ({ text }) => {
  const translated = useGoogleTranslate(text);
  return translated;
};

export default TranslatedText;

